import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { ConsentChoice } from '@/lib/consent';

/**
 * Cookie consent banner of the public pages (B3-home, DES-14: it appears on
 * public pages only). Accept and refuse carry the same weight, as the CNIL
 * asks; closing the page without choosing loads nothing.
 */
export function ConsentBanner({ onChoice }: { onChoice: (choice: ConsentChoice) => void }) {
  const { t } = useTranslation(['common']);
  return (
    <section
      role="region"
      aria-label={t('common:consent.label')}
      className="fixed inset-x-0 bottom-0 z-50 border-t px-4 py-4 sm:px-6"
      style={{ background: 'var(--vf-bg)', borderColor: 'var(--vf-border)', color: 'var(--vf-text-1)' }}
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-[13px] leading-relaxed" style={{ color: 'var(--vf-text-2)' }}>
          {t('common:consent.body')}{' '}
          <Link to="/confidential" className="underline" style={{ color: 'var(--vf-accent-text)' }}>
            {t('common:consent.policy')}
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => onChoice('denied')}
            className="min-h-[44px] flex-1 rounded-vf border px-4 text-[13px] font-medium sm:flex-none"
            style={{ borderColor: 'var(--vf-border)', color: 'var(--vf-text-1)', background: 'var(--vf-bg)' }}
          >
            {t('common:consent.refuse')}
          </button>
          <button
            type="button"
            onClick={() => onChoice('granted')}
            className="min-h-[44px] flex-1 rounded-vf border px-4 text-[13px] font-medium sm:flex-none"
            style={{ borderColor: 'var(--vf-border)', color: 'var(--vf-text-1)', background: 'var(--vf-bg)' }}
          >
            {t('common:consent.accept')}
          </button>
        </div>
      </div>
    </section>
  );
}
